import api from '../../utils/axios';

const state = {
  isAdmin: false,
  permissions: [],
  loading: false,
  error: null
};

const mutations = {
  SET_ADMIN_STATUS(state, isAdmin) {
    state.isAdmin = isAdmin;
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

const actions = {
  // 检查管理员状态
  async checkAdminStatus({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.get('/admin/status');
      commit('SET_ADMIN_STATUS', response.isAdmin);
      commit('SET_PERMISSIONS', response.permissions);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取管理员状态失败';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  isAdmin: state => state.isAdmin,
  permissions: state => state.permissions,
  hasPermission: state => permission => state.permissions.includes(permission),
  isLoading: state => state.loading,
  error: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 